import {Component} from '@angular/core';
import { NavController, Platform } from 'ionic-angular';
import { AdsProvider } from '../../../providers/ads/ads';
import { ScreenRotatableService } from '../../../providers/screen-rotatable/screen-rotatable.service';
import { TrophyComponent } from '../../../components/trophy/trophy';
import { Subject} from 'rxjs';

@Component({
  selector: 'page-event-activity-tabs',
  templateUrl: 'event-activity-tabs.html'
})
export class EventActivityTabsPage{

  tab: string = "activity";
  instance;
  defaultOrientation: boolean = true;
  activeEndurance = null;
  orientationSub = null;

  trophySwapSubject = new Subject();
  isPremium:boolean=false;

  constructor(
    public navCtrl: NavController,
    private screen: ScreenRotatableService,
    private ads: AdsProvider,
    private platform: Platform
  ) {
    // if(!this.isPremium) this.ads.show()
    this.instance = this;
  }
  lastActiveTrophy = -1;
  isCreated: boolean = false;
  onScroll(event) {
    console.log('scrolling...');
    const trophyTargets = document.querySelectorAll('.trophy-target');
    for (let i = 0; i < trophyTargets.length; i++) {
      const rect = trophyTargets[i].getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        // The trophy-target is currently visible
        if (this.lastActiveTrophy != i) {
          // if (!this.isCreated) {
          //   console.log('create trophy!');
          //   this.isCreated = true;
          this.trophySwapSubject.next(i);
          setTimeout(() => {
            const div1 = document.getElementById('default-trophy');
            const div2 = document.getElementById('trophy-target' + i);

            const clone = div2.cloneNode(true); // create a clone of div1

            div2.parentNode.replaceChild(div1, div2);
            div1.parentNode.insertBefore(clone, div1.nextSibling); // insert the clone after div2
            this.lastActiveTrophy = i;
          }, 300);
          // } else {
          //   console.log('trophy swap!');
          //   const div1 = document.getElementById('trophy-target' + this.lastActiveTrophy);
          //   const div2 = document.getElementById('trophy-target' + i);
          //   const clone = div2.cloneNode(true); // create a clone of div1

          //   div2.parentNode.replaceChild(div1, div2);
          //   div1.parentNode.insertBefore(clone, div1.nextSibling); // insert the clone after div2
          // }
          console.log('last index now ' + this.lastActiveTrophy);
        }
        break;
      }
    }
  }

  ionViewWillEnter() {
    this.orientationSub = this.screen.onChange.subscribe(() => {
      this.defaultOrientation = this.screen.getOrientationType().includes('landscape') ? false : true;
    });
  }

  ionViewWillLeave() {
    if (this.platform.is('cordova')) {
      this.screen.lockPortraitOrientation();
    }
  }


}



// WEBPACK FOOTER //
// /src/pages/event/event-activity-tabs/event-activity-tabs.ts